<template>
  <div class="property-deduction-report">
    <!-- 平台托管账户 -->
    <el-card v-if="isPlatformAdmin" class="margin-bottom">
      <div slot="header">
        <span>平台抵扣金托管账户</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="loadPlatformAccount">
          刷新
        </el-button>
      </div>
      <el-row>
        <el-col :span="8">
          <div class="stat-item">
            <div class="stat-label">账户ID</div>
            <div class="stat-value">{{ platformAccount.acctId || '-' }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stat-item">
            <div class="stat-label">账户余额</div>
            <div class="stat-value text-primary">{{ formatMoney(platformAccount.amount) }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stat-item">
            <div class="stat-label">账户状态</div>
            <div class="stat-value">{{ formatPlatformStatus(platformAccount.statusCd) }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <div slot="header">抵扣金管理报表</div>
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <!-- 用户余额 -->
        <el-tab-pane v-if="isPlatformAdmin" label="用户余额" name="userBalance">
          <div class="query-bar">
            <el-form :inline="true" :model="userBalanceQuery" size="small">
              <el-form-item label="用户姓名">
                <el-input v-model="userBalanceQuery.userName" placeholder="用户姓名" clearable />
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="userBalanceQuery.tel" placeholder="手机号" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryUserBalance(1)">查询</el-button>
                <el-button @click="resetUserBalance">重置</el-button>
                <el-button type="success" @click="exportUserBalance">导出 Excel</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="userBalanceList" border stripe style="width: 100%">
            <el-table-column prop="userName" label="用户姓名" align="center">
              <template #default="{ row }">{{ row.userName || '-' }}</template>
            </el-table-column>
            <el-table-column prop="tel" label="手机号" align="center" />
            <el-table-column prop="availableAmount" label="可用余额" align="center">
              <template #default="{ row }">{{ formatMoney(row.availableAmount) }}</template>
            </el-table-column>
            <el-table-column prop="goodsAvailableAmount" label="商城专用抵扣金" align="center">
              <template #default="{ row }">{{ formatMoney(row.goodsAvailableAmount) }}</template>
            </el-table-column>
            <el-table-column prop="propertyAvailableAmount" label="通用抵扣金" align="center">
              <template #default="{ row }">{{ formatMoney(row.propertyAvailableAmount) }}</template>
            </el-table-column>
            <el-table-column prop="frozenAmount" label="冻结金额" align="center">
              <template #default="{ row }">{{ formatMoney(row.frozenAmount) }}</template>
            </el-table-column>
            <el-table-column prop="totalIncome" label="累计收入" align="center">
              <template #default="{ row }">{{ formatMoney(row.totalIncome) }}</template>
            </el-table-column>
            <el-table-column prop="totalUsed" label="累计支出" align="center">
              <template #default="{ row }">{{ formatMoney(row.totalUsed) }}</template>
            </el-table-column>
            <el-table-column prop="statusCd" label="状态" align="center">
              <template #default="{ row }">{{ formatStatus(row.statusCd) }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" />
          </el-table>
          <el-pagination
            class="pagination"
            background
            layout="total, prev, pager, next"
            :current-page="userBalanceQuery.page"
            :page-size="userBalanceQuery.row"
            :total="userBalanceTotal"
            @current-change="handleUserBalancePageChange"
          />
        </el-tab-pane>

        <!-- 明细流水 -->
        <el-tab-pane label="明细流水" name="detail">
          <div class="query-bar">
            <el-form :inline="true" :model="detailQuery" size="small">
              <el-form-item label="订单编号">
                <el-input v-model="detailQuery.orderNo" placeholder="订单编号" clearable />
              </el-form-item>
              <el-form-item label="用户姓名">
                <el-input v-model="detailQuery.userName" placeholder="用户姓名" clearable />
              </el-form-item>
              <el-form-item label="类型">
                <el-select v-model="detailQuery.detailType" placeholder="全部" clearable>
                  <el-option label="收入" value="1001" />
                  <el-option label="支出" value="1002" />
                  <el-option label="冻结" value="1003" />
                  <el-option label="解冻" value="1004" />
                  <el-option label="退款回退" value="1005" />
                </el-select>
              </el-form-item>
              <el-form-item label="来源">
                <el-select v-model="detailQuery.sourceType" placeholder="全部" clearable>
                  <el-option label="充值" value="2001" />
                  <el-option label="消费" value="2002" />
                  <el-option label="冻结" value="2003" />
                  <el-option label="解冻" value="2004" />
                  <el-option label="退款回退" value="2005" />
                </el-select>
              </el-form-item>
              <el-form-item label="余额类型">
                <el-select v-model="detailQuery.balanceType" placeholder="全部" clearable>
                  <el-option label="商城专用抵扣金" value="GOODS" />
                  <el-option label="通用抵扣金" value="PROPERTY" />
                </el-select>
              </el-form-item>
              <el-form-item label="商户小区">
                <el-input v-model="detailQuery.shopCommunityName" placeholder="商户小区名称" clearable />
              </el-form-item>
              <el-form-item label="缴费小区">
                <el-input v-model="detailQuery.paymentCommunityName" placeholder="缴费小区名称" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryDetail(1)">查询</el-button>
                <el-button @click="resetDetail">重置</el-button>
                <el-button type="success" @click="exportDetail">导出 Excel</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="detailList" border stripe style="width: 100%">
            <el-table-column prop="userName" label="用户姓名" align="center">
              <template #default="{ row }">{{ row.userName || '-' }}</template>
            </el-table-column>
            <el-table-column prop="orderNo" label="订单编号" align="center">
              <template #default="{ row }">{{ row.orderNo || row.orderId || '-' }}</template>
            </el-table-column>
            <el-table-column prop="businessName" label="业务信息" align="center" show-overflow-tooltip>
              <template #default="{ row }">{{ row.businessName || row.businessId || '-' }}</template>
            </el-table-column>
            <el-table-column prop="amount" label="金额" align="center">
              <template #default="{ row }">{{ formatMoney(row.amount) }}</template>
            </el-table-column>
            <el-table-column prop="balanceType" label="余额类型" align="center">
              <template #default="{ row }">{{ formatBalanceType(row.balanceType) }}</template>
            </el-table-column>
            <el-table-column prop="detailType" label="类型" align="center">
              <template #default="{ row }">{{ formatDetailType(row.detailType) }}</template>
            </el-table-column>
            <el-table-column prop="sourceType" label="来源" align="center">
              <template #default="{ row }">{{ formatSourceType(row.sourceType) }}</template>
            </el-table-column>
            <el-table-column prop="shopCommunityNameWithCode" label="商户小区" align="center" show-overflow-tooltip>
              <template #default="{ row }">{{ formatCommunityName(row.shopCommunityNameWithCode) }}</template>
            </el-table-column>
            <el-table-column prop="paymentCommunityNameWithCode" label="缴费小区" align="center" show-overflow-tooltip>
              <template #default="{ row }">{{ formatCommunityName(row.paymentCommunityNameWithCode) }}</template>
            </el-table-column>
            <el-table-column prop="syncStatus" label="同步状态" align="center">
              <template #default="{ row }">{{ formatSyncStatus(row.syncStatus) }}</template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip />
            <el-table-column prop="createTime" label="创建时间" align="center" />
            <el-table-column label="操作" align="center" width="80">
              <template #default="{ row }">
                <el-button type="text" size="small" @click="showDetail(row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            background
            layout="total, prev, pager, next"
            :current-page="detailQuery.page"
            :page-size="detailQuery.row"
            :total="detailTotal"
            @current-change="handleDetailPageChange"
          />
        </el-tab-pane>

        <!-- 资金来源统计 -->
        <el-tab-pane label="资金来源统计" name="sourceByCommunity">
          <div class="query-bar">
            <el-form :inline="true" :model="sourceQuery" size="small">
              <el-form-item label="商户小区">
                <el-input v-model="sourceQuery.shopCommunityName" placeholder="商户小区名称" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="querySource">查询</el-button>
                <el-button @click="resetSource">重置</el-button>
                <el-button type="success" @click="exportSource">导出 Excel</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="sourceList" border stripe style="width: 100%">
            <el-table-column prop="shopCommunityNameWithCode" label="商户小区" align="center" show-overflow-tooltip>
              <template #default="{ row }">{{ formatCommunityName(row.shopCommunityNameWithCode) }}</template>
            </el-table-column>
            <el-table-column prop="recordCount" label="笔数" align="center" />
            <el-table-column prop="totalAmount" label="资金流入合计" align="center">
              <template #default="{ row }">{{ formatMoney(row.totalAmount) }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 资金去向统计 -->
        <el-tab-pane v-if="isPlatformAdmin" label="资金去向统计" name="useByCommunity">
          <div class="query-bar">
            <el-form :inline="true" :model="useQuery" size="small">
              <el-form-item label="缴费小区">
                <el-input v-model="useQuery.paymentCommunityName" placeholder="缴费小区名称" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryUse">查询</el-button>
                <el-button @click="resetUse">重置</el-button>
                <el-button type="success" @click="exportUse">导出 Excel</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="useList" border stripe style="width: 100%">
            <el-table-column prop="paymentCommunityNameWithCode" label="缴费小区" align="center" show-overflow-tooltip>
              <template #default="{ row }">{{ formatCommunityName(row.paymentCommunityNameWithCode) }}</template>
            </el-table-column>
            <el-table-column prop="recordCount" label="笔数" align="center" />
            <el-table-column prop="totalAmount" label="资金流出合计" align="center">
              <template #default="{ row }">{{ formatMoney(row.totalAmount) }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog title="抵扣金明细详情" :visible.sync="detailDialogVisible" width="700px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="明细ID">{{ currentDetail.pddId }}</el-descriptions-item>
        <el-descriptions-item label="账户ID">{{ currentDetail.pdId }}</el-descriptions-item>
        <el-descriptions-item label="用户姓名">{{ currentDetail.userName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ currentDetail.tel || '-' }}</el-descriptions-item>
        <el-descriptions-item label="订单编号">{{ currentDetail.orderNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="订单ID">{{ currentDetail.orderId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="业务信息">{{ currentDetail.businessName || currentDetail.businessId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="业务ID">{{ currentDetail.businessId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="金额">{{ formatMoney(currentDetail.amount) }}</el-descriptions-item>
        <el-descriptions-item label="余额类型">{{ formatBalanceType(currentDetail.balanceType) }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ formatDetailType(currentDetail.detailType) }}</el-descriptions-item>
        <el-descriptions-item label="来源">{{ formatSourceType(currentDetail.sourceType) }}</el-descriptions-item>
        <el-descriptions-item label="商户小区">{{ formatCommunityName(currentDetail.shopCommunityNameWithCode) }}</el-descriptions-item>
        <el-descriptions-item label="缴费小区">{{ formatCommunityName(currentDetail.paymentCommunityNameWithCode) }}</el-descriptions-item>
        <el-descriptions-item label="同步状态">{{ formatSyncStatus(currentDetail.syncStatus) }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ currentDetail.createTime || '-' }}</el-descriptions-item>
      </el-descriptions>
      <el-row style="margin-top: 16px;">
        <el-col :span="24">
          <strong>同步消息：</strong>{{ currentDetail.syncMsg || '-' }}
        </el-col>
      </el-row>
      <el-row style="margin-top: 8px;">
        <el-col :span="24">
          <strong>备注：</strong>{{ currentDetail.remark || '-' }}
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { propertyDeductionAdmin } from '@/api/property/propertyDeductionApi'
import { queryShopDeductionReport } from '@/api/property/propertyDeductionApi'
import { getStoreInfo } from '@/api/user/indexApi'

export default {
  name: 'PropertyDeductionReport',
  data() {
    return {
      activeTab: 'userBalance',
      platformAccount: {},
      isPlatformAdmin: false,

      userBalanceQuery: {
        userName: '',
        tel: '',
        page: 1,
        row: 10,
        action: 'queryUserBalance'
      },
      userBalanceList: [],
      userBalanceTotal: 0,

      detailQuery: {
        orderNo: '',
        userName: '',
        detailType: '',
        sourceType: '',
        balanceType: '',
        shopCommunityName: '',
        paymentCommunityName: '',
        page: 1,
        row: 10,
        action: 'queryDetail'
      },
      detailList: [],
      detailTotal: 0,

      sourceQuery: {
        shopCommunityName: '',
        action: 'querySourceByCommunity'
      },
      sourceList: [],

      useQuery: {
        paymentCommunityName: '',
        action: 'queryUseByCommunity'
      },
      useList: [],

      detailDialogVisible: false,
      currentDetail: {}
    }
  },
  async created() {
    await this.loadStoreInfo()
    this.activeTab = this.isPlatformAdmin ? 'userBalance' : 'detail'
    if (this.isPlatformAdmin) {
      this.loadPlatformAccount()
      this.queryUserBalance(1)
    } else {
      this.queryDetail(1)
    }
  },
  methods: {
    async loadStoreInfo() {
      try {
        const res = await getStoreInfo()
        const storeInfo = (res.data && res.data[0]) || {}
        this.isPlatformAdmin = storeInfo.storeTypeCd === '800900000001'
      } catch (error) {
        console.error('获取商户信息失败:', error)
        this.isPlatformAdmin = false
      }
    },
    handleTabClick(tab) {
      if (tab.name === 'userBalance') {
        this.queryUserBalance(1)
      } else if (tab.name === 'detail') {
        this.queryDetail(1)
      } else if (tab.name === 'sourceByCommunity') {
        this.querySource()
      } else if (tab.name === 'useByCommunity') {
        this.queryUse()
      }
    },

    async loadPlatformAccount() {
      try {
        const res = await propertyDeductionAdmin({ action: 'queryPlatformAccount' })
        this.platformAccount = res.data || {}
      } catch (error) {
        console.error('查询平台托管账户失败:', error)
      }
    },

    async queryUserBalance(page = 1) {
      this.userBalanceQuery.page = page
      try {
        const res = await propertyDeductionAdmin({ ...this.userBalanceQuery })
        this.userBalanceList = res.data || []
        this.userBalanceTotal = res.total || 0
      } catch (error) {
        console.error('查询用户余额失败:', error)
      }
    },
    handleUserBalancePageChange(val) {
      this.queryUserBalance(val)
    },
    resetUserBalance() {
      this.userBalanceQuery.userName = ''
      this.userBalanceQuery.tel = ''
      this.queryUserBalance(1)
    },
    exportUserBalance() {
      const headers = ['用户姓名', '手机号', '可用余额', '商城专用抵扣金', '通用抵扣金', '冻结金额', '累计收入', '累计支出', '状态', '创建时间']
      const rows = this.userBalanceList.map(row => [
        row.userName || '-',
        row.tel,
        this.formatMoney(row.availableAmount),
        this.formatMoney(row.goodsAvailableAmount),
        this.formatMoney(row.propertyAvailableAmount),
        this.formatMoney(row.frozenAmount),
        this.formatMoney(row.totalIncome),
        this.formatMoney(row.totalUsed),
        this.formatStatus(row.statusCd),
        row.createTime
      ])
      this.exportExcel('用户抵扣金余额', headers, rows)
    },

    async queryDetail(page = 1) {
      this.detailQuery.page = page
      try {
        const api = this.isPlatformAdmin ? propertyDeductionAdmin : queryShopDeductionReport
        const res = await api({ ...this.detailQuery, action: 'queryDetail' })
        this.detailList = res.data || []
        this.detailTotal = res.total || 0
      } catch (error) {
        console.error('查询明细失败:', error)
      }
    },
    handleDetailPageChange(val) {
      this.queryDetail(val)
    },
    resetDetail() {
      this.detailQuery.orderNo = ''
      this.detailQuery.userName = ''
      this.detailQuery.detailType = ''
      this.detailQuery.sourceType = ''
      this.detailQuery.balanceType = ''
      this.detailQuery.shopCommunityName = ''
      this.detailQuery.paymentCommunityName = ''
      this.queryDetail(1)
    },
    exportDetail() {
      const headers = ['用户姓名', '订单编号', '业务信息', '金额', '余额类型', '类型', '来源', '商户小区', '缴费小区', '同步状态', '备注', '创建时间', '明细ID', '订单ID', '业务ID']
      const rows = this.detailList.map(row => [
        row.userName || '-',
        row.orderNo || row.orderId || '-',
        row.businessName || row.businessId || '-',
        this.formatMoney(row.amount),
        this.formatBalanceType(row.balanceType),
        this.formatDetailType(row.detailType),
        this.formatSourceType(row.sourceType),
        this.formatCommunityName(row.shopCommunityNameWithCode),
        this.formatCommunityName(row.paymentCommunityNameWithCode),
        this.formatSyncStatus(row.syncStatus),
        row.remark,
        row.createTime,
        row.pddId,
        row.orderId,
        row.businessId
      ])
      this.exportExcel('抵扣金明细流水', headers, rows)
    },

    async querySource() {
      try {
        const api = this.isPlatformAdmin ? propertyDeductionAdmin : queryShopDeductionReport
        const res = await api({ ...this.sourceQuery, action: 'querySourceByCommunity' })
        this.sourceList = res.data || []
      } catch (error) {
        console.error('查询资金来源统计失败:', error)
      }
    },
    resetSource() {
      this.sourceQuery.shopCommunityName = ''
      this.querySource()
    },
    exportSource() {
      const headers = ['商户小区', '笔数', '资金流入合计']
      const rows = this.sourceList.map(row => [
        this.formatCommunityName(row.shopCommunityNameWithCode),
        row.recordCount,
        this.formatMoney(row.totalAmount)
      ])
      this.exportExcel('抵扣金资金来源统计', headers, rows)
    },

    async queryUse() {
      try {
        const res = await propertyDeductionAdmin({ ...this.useQuery })
        this.useList = res.data || []
      } catch (error) {
        console.error('查询资金去向统计失败:', error)
      }
    },
    resetUse() {
      this.useQuery.paymentCommunityName = ''
      this.queryUse()
    },
    exportUse() {
      const headers = ['缴费小区', '笔数', '资金流出合计']
      const rows = this.useList.map(row => [
        this.formatCommunityName(row.paymentCommunityNameWithCode),
        row.recordCount,
        this.formatMoney(row.totalAmount)
      ])
      this.exportExcel('抵扣金资金去向统计', headers, rows)
    },

    formatCommunityName(value) {
      if (!value || value === '()') {
        return '-'
      }
      return value
    },
    formatMoney(value) {
      if (value === undefined || value === null || value === '') {
        return '0.00'
      }
      const num = parseFloat(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    formatStatus(statusCd) {
      if (statusCd === '0') return '正常'
      if (statusCd === '1') return '冻结'
      return statusCd || '-'
    },
    formatDetailType(detailType) {
      if (detailType === '1001') return '收入'
      if (detailType === '1002') return '支出'
      if (detailType === '1003') return '冻结'
      if (detailType === '1004') return '解冻'
      if (detailType === '1005') return '退款回退'
      return detailType || '-'
    },
    formatBalanceType(balanceType) {
      if (balanceType === 'GOODS') return '商城专用抵扣金'
      if (balanceType === 'PROPERTY') return '通用抵扣金'
      return balanceType || '-'
    },
    formatSourceType(sourceType) {
      if (sourceType === '2001') return '充值'
      if (sourceType === '2002') return '消费'
      if (sourceType === '2003') return '冻结'
      if (sourceType === '2004') return '解冻'
      if (sourceType === '2005') return '退款回退'
      return sourceType || '-'
    },
    formatSyncStatus(syncStatus) {
      if (syncStatus === '0') return '未同步'
      if (syncStatus === '1') return '已同步'
      if (syncStatus === '2') return '失败'
      return syncStatus || '-'
    },
    formatPlatformStatus(statusCd) {
      if (statusCd === '0') return '正常'
      if (statusCd === '1') return '停用'
      return statusCd || '-'
    },

    async showDetail(row) {
      if (!this.isPlatformAdmin) {
        this.currentDetail = row || {}
        this.detailDialogVisible = true
        return
      }
      try {
        const res = await propertyDeductionAdmin({ action: 'queryDetailById', pddId: row.pddId })
        this.currentDetail = res.data || {}
        this.detailDialogVisible = true
      } catch (error) {
        console.error('查询详情失败:', error)
        this.$message.error('查询详情失败')
      }
    },

    exportExcel(sheetName, headers, rows) {
      if (!rows || rows.length === 0) {
        this.$message.warning('暂无数据可导出')
        return
      }
      const allRows = [headers, ...rows]
      const csvContent = allRows.map(row =>
        row.map(cell => {
          const text = cell == null ? '' : String(cell)
          // 处理逗号、换行和引号
          if (/[,"\n\r]/.test(text)) {
            return '"' + text.replace(/"/g, '""') + '"'
          }
          return text
        }).join(',')
      ).join('\n')

      const blob = new Blob(['﻿' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.href = url
      link.download = `${sheetName}_${this.formatDate(new Date())}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}${m}${d}`
    }
  }
}
</script>

<style scoped>
.property-deduction-report {
  padding: 20px;
}
.margin-bottom {
  margin-bottom: 20px;
}
.query-bar {
  margin-bottom: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
.stat-item {
  text-align: center;
  padding: 20px 0;
}
.stat-label {
  color: #909399;
  font-size: 14px;
  margin-bottom: 10px;
}
.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}
.text-primary {
  color: #409EFF;
}
.text-warning {
  color: #E6A23C;
}
</style>
